"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11 8c0-.15-.07-.28-.17-.37l-4-3.5A.495.495 0 006 4.5v7a.495.495 0 00.83.37l4-3.5c.1-.09.17-.22.17-.37z"];
//# sourceMappingURL=caret-right.js.map